import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import {ContactService} from '../contact.service';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ContactEditComponent } from '../contact-edit/contact-edit.component';

export interface DuplicateContactEditDialogData {
  id: string;
}

@Component({
    selector: 'app-duplicate-contact-edit-dialog',
    template: `
      <div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
          <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
              <div fxFlex>Edit Contact</div>
              <button mat-icon-button [mat-dialog-close]="false" class="button-40">
                  <mat-icon>close</mat-icon>
              </button>
          </h1>
          <div mat-dialog-content fxFlex>
              <app-contact-edit [isModal]="true" [contactId]="data.id" (onSaveOrDelete)="onSaveOrDelete($event)"></app-contact-edit>
          </div>
      </div>
  `,
    styles: [],
    standalone: true,
    imports: [FlexModule, MatDialogTitle, MatIconButton, MatDialogClose, MatIcon, CdkScrollable, MatDialogContent, ContactEditComponent]
})
export class DuplicatesEditDialogComponent {

  constructor(public dialogRef: MatDialogRef<DuplicatesEditDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DuplicateContactEditDialogData,
              public dialog: MatDialog,
              public contactService: ContactService,
  ) {

  }

  closeSendConfirmPopup(action: string) {
    this.dialogRef.close(action);
  }

  onSaveOrDelete($event: boolean) {
    if ($event) {
      this.dialogRef.close('refresh');
    }
  }
}
